#import "../../../sms/broadcasts/graphql/fragments/sms-edition-fragment.graphql"

query GetSmsEditions(
    $first: Int!
    $after: String
    $sort: EditionSortType
    $audienceId: ID
    $campaignTypes: [CampaignType!]
    $statuses: [EditionStatus!]
) {
    smsEditions(
        first: $first
        after: $after
        audienceId: $audienceId
        campaignTypes: $campaignTypes
        statuses: $statuses
        sort: $sort
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...SmsEditionFragment
            }
        }
    }
}
